// @flow
import { combineReducers } from 'redux';

import * as types from '../types/gateways';
import * as common from './common';
import type { ERROR_TYPE, ID_TYPE } from '../types/common';
import type { GATEWAY_TYPE, GATEWAYS_ACTION_TYPE } from '../types/gateways';

export type GatewaysState = {
  byId: { [ID_TYPE]: GATEWAY_TYPE },
  order: Array<ID_TYPE>,
  fetchingUsers: Array<number>,
  isFetching: boolean,
  gatewayUsersNextPage: {[number]: number},
  errors: { [number]: ERROR_TYPE },
  current: ID_TYPE,
};

const byId = common.byId({
  added: [types.GATEWAYS_FETCH_SUCCESS, types.GATEWAY_CREATE_SUCCESS],
  fetched: [types.GATEWAYS_FETCH_SUCCESS],
  updated: [
    types.UPDATE_GATEWAY_USERS_SUCCEED,
    types.ADD_GATEWAY_USER_SUCCESS,
    types.REMOVE_GATEWAY_USER_SUCCESS,
    types.UPDATE_GATEWAY_ACTION_SUCCEDED,
    types.UPDATE_GATEWAY_SUCCEDED,
  ],
  addedToArrayAttribute: [
    types.GATEWAY_USERS_FETCH_SUCCESS,
  ],
  removed: [types.REMOVE_GATEWAY_SUCCEED],
});

const errors = common.errors({
  populate: [types.GATEWAYS_FETCH_FAILED],
  clear: [types.GATEWAYS_FETCH_FAILED],
});

const isFetching = common.isFetching({
  started: [types.GATEWAYS_FETCH_STARTED],
  succeed: [
    types.GATEWAYS_FETCH_SUCCESS,
    types.UPDATE_GATEWAY_USERS_SUCCEED,
  ],
  failed: [types.GATEWAYS_FETCH_FAILED],
});

const order = common.order({
  fetched: [types.GATEWAYS_FETCH_SUCCESS],
  added: [types.GATEWAYS_FETCH_SUCCESS, types.GATEWAY_CREATE_SUCCESS],
  removed: [types.REMOVE_GATEWAY_SUCCEED],
});

const fetchingUsers = common.fetching({
  started: [types.GATEWAY_USERS_FETCH_STARTED],
  succeed: [types.GATEWAYS_FETCH_SUCCESS],
  failed: [types.GATEWAYS_USERS_FETCH_FAILED],
});


const gatewayUsersNextPage = (
  state: {[number]: number} = {},
  action: GATEWAYS_ACTION_TYPE,
): {[number]: number} => {
  switch (action.type) {
    case types.UPDATE_GATEWAY_USERS_PAGE: {
      const { id, page: next}  = action.payload;
      const { page = -1 } = state[id] || {};
      
      let newPage = next;

      if (next != null && next > 2) {
        newPage = Math.max(page, next);
      }

      return {
        ...state,
        [id]: newPage,
      };
    }

    case types.GATEWAYS_USERS_FETCH_FAILED: {
      const { object_id = -1 } = action.payload;
      return {
        ...state,
        [object_id]: -1,
      }
    }

    default: {
      return state;
    }
  }
};

const current = common.mux({
  selected: [types.GATEWAY_SELECTED],
  // allDeselected: [],
  default: -1,
});

const gateways = combineReducers({
  byId,
  errors,
  isFetching,
  order,
  gatewayUsersNextPage,
  fetchingUsers,
  current,
});

export default gateways;

export const getGateway = (state: GatewaysState, id: ID_TYPE): GATEWAY_TYPE => state.byId[id];
export const getGateways = (state: GatewaysState): Array<GATEWAY_TYPE> => state.order.map(
  id => getGateway(state, id),
);
export const getGatewayPage = (state: GatewaysState, id: number): number => state.gatewayUsersNextPage[id];
export const hasMoreGateways = (state: GatewaysState, id: number): boolean => {
  const nextPage = state.gatewayUsersNextPage[id];
  if (nextPage === null || typeof nextPage === 'undefined' || nextPage <= 0) {
    return false
  }
  return true;
}
export const areGatewaysFetching = (state: GatewaysState): boolean => state.isFetching;
export const getGatewaysChangeStopAvailable = (state: GatewaysState): Array<GATEWAY_TYPE> => {
  const filteredIds = state.order.filter(elm => state.byId[elm].allow_change_requests);
  return filteredIds.map(elm => state.byId[elm]);
};
export const getCurrentGateway = (state: GatewaysState): GATEWAY_TYPE => getGateway(state, state.current);



// WEBPACK FOOTER //
// ./src/scripts/reducers/gateways.js